import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { RenewalInfoComponent } from './renewal-info.component';
import { MatDividerModule } from "@angular/material/divider";

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule
],
  exports: [
    RenewalInfoComponent
  ],
  providers: [
  ],
  declarations: [
    RenewalInfoComponent
  ]
})
export class RenewalInfoModule { }
